import React, { createContext, useContext, useState, useCallback } from 'react';
import { useWorkflowValidation } from '../../../hooks/useWorkflowValidation';
import { ValidationErrors } from '../../../../../services/WorkflowService';

interface WorkflowValidationContextValue {
  errors: ValidationErrors;
  isValid: boolean;
  isEdited: boolean;
  showErrors: boolean;
  triggerValidation: () => boolean;
  resetValidation: () => void;
}

const WorkflowValidationContext = createContext<WorkflowValidationContextValue>({
  errors: {},
  isValid: true,
  isEdited: false,
  showErrors: false,
  triggerValidation: () => true,
  resetValidation: () => {},
});

export const useWorkflowValidationContext = () => useContext(WorkflowValidationContext);

export const WorkflowValidationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { errors, isValid, isEdited } = useWorkflowValidation();
  const [showErrors, setShowErrors] = useState(false);

  const triggerValidation = useCallback(() => {
    setShowErrors(true);
    return isValid;
  }, [isValid]);

  const resetValidation = useCallback(() => setShowErrors(false), []);

  return (
    <WorkflowValidationContext.Provider value={{ errors, isValid, isEdited, showErrors, triggerValidation, resetValidation }}>
      {children}
    </WorkflowValidationContext.Provider>
  );
};
